import React, { useState } from 'react';
import { Button, Modal, Offcanvas, Spinner } from 'react-bootstrap';
import { useAuth } from '../../../../../../context/AuthContext';
import { toast } from 'react-toastify';
import { db } from '../../../../../../firebase';
import { addDoc, collection } from 'firebase/firestore';
import CallForm from '../../../../../leads/form/call';

const AddCall = ({ leadID, showModal, setShowModal }) => {

  const { user } = useAuth();
  const { bid } = user.claims;

  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState({
    callStatus: "Busy",
    callDate: new Date(),
    note: "",
    type: "calls",
    createdBy: user?.uid || "",
    createdAt: new Date(),
    updatedAt: new Date()
  });
  const [inputError, setInputError] = useState(null)

  const resetForm = () => {
    setData({
      callStatus: "Busy",
      callDate: new Date(),
      note: "",
      type: "calls",
      createdBy: user?.uid || "",
      createdAt: new Date(),
      updatedAt: new Date()
    });
  }

  const validateAndPostData = async () => {
    const { callStatus, callDate, note } = data;

    if (!callStatus) {
      setInputError({ ...inputError, callStatus: 'This field is required.' });
    } else if (!callDate) {
      setInputError({ ...inputError, callDate: 'This field is required.' });
    } else if (!note) {
      setInputError({ ...inputError, note: 'This field is required.' });
    } else {
      const docRef = await addDoc(collection(db, "Businesses", bid, "Leads", leadID, "Activities"), data);

      if (docRef.id) {
        setShowModal(false);
        toast.success("Call added, successfully.");
      }
    }
  }

  return (
    <Modal
      show={showModal}
      onHide={() => {
        setShowModal(false);
        resetForm();
      }}
      backdrop="static"
      keyboard={false}
      centered
    >
      <div className='modal-header py-4 border-bottom'>
        <h5 className='mb-0'>Add Call Log</h5>
        <Button
          variant='none'
          className='btn-close px-3'
          onClick={() => {
            setShowModal(false);
            resetForm();
          }}
        />
      </div>
      <div className='modal-body p-0'>
        <div className='px-4'>
          <CallForm
            data={data}
            setData={setData}
            inputError={inputError}
            setInputError={setInputError}
          />
        </div>
      </div>
      <div className='modal-footer px-3 py-3 border-top align-items-center justify-content-between'>
        <Button
          variant="outline-danger"
          onClick={() => {
            setShowModal(false);
            resetForm();
          }}
          className='px-5 py-2 btn-width'
        >
          Cancel
        </Button>
        {
          isLoading ?
            <Button
              disabled
              variant="primary"
              className='px-5 py-2 btn-width'
              onClick={() => null}
            >
              <Spinner />
            </Button>
            :
            <Button
              variant="primary"
              className='px-5 py-2 btn-width'
              onClick={() => validateAndPostData()}
            >
              Save
            </Button>
        }
      </div>
    </Modal>
  )
}

export default AddCall;
